import D2C_Host from '../Host'
import objects from '@/objects'
import store from '@/store'

class D2C_HostCloud extends D2C_Host {
  isCloud = true
  static objectType = 'hostGroup'
  static groupName = 'cloud'
  static groupTitle = 'Cloud'
  static actions = {
    ...D2C_Host.actions,
    RECREATE: 'RECREATE',
    RESTART: 'RESTART',
  }
  static processes = {
    ...D2C_Host.processes,
    CREATING: 'CREATING',
    RESIZING: 'RESIZING',
    RESTARTING: 'RESTARTING',
    UPDATING_DISK: 'UPDATING_DISK',
  }
  static methods = {
    ...D2C_Host.methods,
    start: true,
    restart: true,
    stop: true,
    recreate: true,
  }
  static fields = {
    ...D2C_Host.fields,
    hours: {
      default: 1,
      label: 'Hours',
      max: 3,
      min: 1,
      width: 3,
      validate(value) {
        if (value < 1) {
          return 'What do you mean?'
        }
        if (value > 3) {
          return `${this.max} is maximum`
        }
        return null
      },
      creatingDemo: {},
    },
    region: {
      default: null,
      label: 'Region',
      placeholder: 'Select...',
      placeholderEmpty: 'No available regions',
      required: true,
      width: 6,
      validate(value) {
        return value ? null : 'Must be selected'
      },
      creating: {},
      creatingDemo: {
        omit: true,
        readonly: true,
        required: false,
      },
    },
    instance: {
      default: null,
      label: 'Instance',
      placeholder: 'Select...',
      placeholderEmpty: 'No available instances',
      required: true,
      width: 10,
      validate(value, entity) {
        if (!value) {
          return 'Must be selected'
        }
        if (entity.requirements) {
          const instance = entity._instance
          const minCores = parseFloat(entity.requirements.cores)
          const minMemory = parseFloat(entity.requirements.memory)
          if (minCores > instance.cores || minMemory > instance.memory) {
            return 'Doesn\'t fit requirements'
          }
        }
        return null
      },
      creating: {},
      creatingDemo: {
        omit: true,
        readonly: true,
        required: false,
      },
      updating: {},
    },
    keys: {
      ...D2C_Host.fields.keys,
      creating: {},
    },
    provider: {
      default: null,
      label: 'Provider',
      placeholder: 'Select...',
      placeholderEmpty: 'No available providers',
      required: true,
      width: 14,
      validate(value) {
        return value ? null : 'Must be selected'
      },
      creating: {},
    },
  }
  static get _provider() {
    return objects._providersByType[this.providerType]
  }
  static get _instances() {
    return this._provider._instances
  }
  static get _regions() {
    return this._provider._regions
  }
  get _provider() {
    return store.getters.providersById[this.provider]
  }
  get _instance() {
    return store.getters.instancesById[this.instance]
  }
  get _region() {
    return store.getters.regionsById[this.region]
  }
  get _keys() {
    return this.keys.map(keyId => store.getters.keysById[keyId])
  }
}

export default D2C_HostCloud
